module.exports = __webpack_public_path__ + "img/john-smc.02a8e79c.jpg";